import { PennDotDistricts, UrbanSubIntxTypes } from "./SPFConstants";
import { COUNTIES } from "../../constants/geographyConstants";

export const getThreeLegMinorStopSpfForDistrict = (
  district: PennDotDistricts
) => {
  switch (district) {
    case PennDotDistricts.DISTRICT_1:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) => {
          return (
            Math.exp(-6.758) *
            Math.pow(majorRoad.aadt, 0.538) *
            Math.pow(minorRoad.aadt, 0.188) *
            Math.exp(0.21 * Number(majorRoad.speedLimit >= 40)) *
            Math.exp(0.356 * Number(minorRoad.speedLimit >= 40))
          );
        },
        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-7.447) *
          Math.pow(majorRoad.aadt, 0.557) *
          Math.pow(minorRoad.aadt, 0.15) *
          Math.exp(0.551 * Number(majorRoad.speedLimit >= 40)),
      };
    case PennDotDistricts.DISTRICT_2:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-6.758) *
          Math.pow(majorRoad.aadt, 0.538) *
          Math.pow(minorRoad.aadt, 0.188) *
          Math.exp(0.21 * Number(majorRoad.speedLimit >= 40)) *
          Math.exp(0.356 * Number(minorRoad.speedLimit >= 40)),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-7.447) *
          Math.pow(majorRoad.aadt, 0.557) *
          Math.pow(minorRoad.aadt, 0.15) *
          Math.exp(0.551 * Number(majorRoad.speedLimit >= 40)),
      };

    case PennDotDistricts.DISTRICT_3:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-8.382) *
          Math.pow(majorRoad.aadt, 0.532) *
          Math.pow(minorRoad.aadt, 0.391) *
          Math.exp(0.344 * Number(majorRoad.speedLimit >= 40)) *
          Math.exp(0.327 * Number(minorRoad.speedLimit >= 40)),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-10.66) *
          Math.pow(majorRoad.aadt, 0.638) *
          Math.pow(minorRoad.aadt, 0.451) *
          Math.exp(0.522 * Number(majorRoad.speedLimit >= 40)) *
          Math.exp(0.486 * Number(minorRoad.speedLimit >= 40)),
      };
    case PennDotDistricts.DISTRICT_4:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-8.655) *
          Math.pow(majorRoad.aadt, 0.662) *
          Math.pow(minorRoad.aadt, 0.362),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-10.98) *
          Math.pow(majorRoad.aadt, 0.884) *
          Math.pow(minorRoad.aadt, 0.323),
      };
    case PennDotDistricts.DISTRICT_5:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-6.255) *
          Math.pow(majorRoad.aadt, 0.403) *
          Math.pow(minorRoad.aadt, 0.35) *
          Math.exp(0.293 * Number(majorRoad.speedLimit >= 40)),
        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-8.088) *
          Math.pow(majorRoad.aadt, 0.549) *
          Math.pow(minorRoad.aadt, 0.321) *
          Math.exp(0.392 * Number(majorRoad.speedLimit >= 40)),
      };
    case PennDotDistricts.DISTRICT_6:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-6.729) *
          Math.pow(majorRoad.aadt, 0.423) *
          Math.pow(minorRoad.aadt, 0.373) *
          Math.exp(0.131 * Number(majorRoad.speedLimit >= 40)),
        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-9.186) *
          Math.pow(majorRoad.aadt, 0.575) *
          Math.pow(minorRoad.aadt, 0.432),
      };
    case PennDotDistricts.DISTRICT_8:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-8.417) *
          Math.pow(majorRoad.aadt, 0.623) *
          Math.pow(minorRoad.aadt, 0.334) *
          Math.exp(0.236 * Number(minorRoad.speedLimit >= 40)),
        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-10.217) *
          Math.pow(majorRoad.aadt, 0.722) *
          Math.pow(minorRoad.aadt, 0.357) *
          Math.exp(0.267 * Number(minorRoad.speedLimit >= 40)),
      };
    case PennDotDistricts.DISTRICT_9:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-7.09) *
          Math.pow(majorRoad.aadt, 0.55) *
          Math.pow(minorRoad.aadt, 0.244),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-8.011) *
          Math.pow(majorRoad.aadt, 0.642) *
          Math.pow(minorRoad.aadt, 0.162),
      };
    case PennDotDistricts.DISTRICT_10:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-7.09) *
          Math.pow(majorRoad.aadt, 0.55) *
          Math.pow(minorRoad.aadt, 0.244),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-8.011) *
          Math.pow(majorRoad.aadt, 0.642) *
          Math.pow(minorRoad.aadt, 0.162),
      };
    case PennDotDistricts.DISTRICT_11:
      return {
        getTotalPredicted: ({
          majorRoad,
          minorRoad,
          county,
        }: UrbanSubIntxTypes) =>
          Math.exp(-9.485) *
          Math.pow(majorRoad.aadt, 0.787) *
          Math.pow(minorRoad.aadt, 0.288) *
          Math.exp(0.153 * Number(majorRoad.speedLimit >= 40)) *
          Math.exp(0.139 * Number(minorRoad.speedLimit >= 40)) *
          (county === COUNTIES.BEAVER ? 1.46 : 1),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
          county,
        }: UrbanSubIntxTypes) =>
          Math.exp(-10.899) *
          Math.pow(majorRoad.aadt, 0.913) *
          Math.pow(minorRoad.aadt, 0.229) *
          Math.exp(0.309 * Number(majorRoad.speedLimit >= 40)) *
          (county === COUNTIES.BEAVER ? 1.56 : 1.0),
      };
    case PennDotDistricts.DISTRICT_12:
      return {
        getTotalPredicted: ({ majorRoad, minorRoad }: UrbanSubIntxTypes) =>
          Math.exp(-9.022) *
          Math.pow(majorRoad.aadt, 0.826) *
          Math.pow(minorRoad.aadt, 0.169) *
          Math.exp(0.245 * Number(majorRoad.speedLimit >= 40)),

        getFatalInjuryPredicted: ({
          majorRoad,
          minorRoad,
        }: UrbanSubIntxTypes) =>
          Math.exp(-10.305) *
          Math.pow(majorRoad.aadt, 0.87) *
          Math.pow(minorRoad.aadt, 0.193) *
          Math.exp(0.351 * Number(majorRoad.speedLimit >= 40)),
      };

    default:
      throw new Error("No SPF for this district");
  }
};
